import { ListGroup, ListGroupItem } from "react-bootstrap"

import { MODALS } from "@/constants/modals"
import { useStore } from "@/zustand/store"

export default function LecturesProjectsModal() {
  const modalData = useStore(
    (state) => state.modalsStates[MODALS.lecture.projects]
  )
  const lecture = modalData?.lecture
  const course = modalData?.course

  if (!modalData) return null

  return (
    <ListGroup>
      {lecture?.project_ids?.map((projectId) => {
        const project = course?.course_projects?.find(
          (p) => p.id === Number(projectId)
        )
        return (
          <ListGroupItem
            className="hoverable"
            key={projectId}
            onClick={() => window.open(project?.link)}
          >
            {project?.name}
          </ListGroupItem>
        )
      })}
    </ListGroup>
  )
}
